'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DynamicTokenContract2 = require('./DynamicTokenContract');

var _DynamicTokenContract3 = _interopRequireDefault(_DynamicTokenContract2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CatToken = function (_DynamicTokenContract) {
  _inherits(CatToken, _DynamicTokenContract);

  function CatToken(eth, config) {
    _classCallCheck(this, CatToken);

    var _this = _possibleConstructorReturn(this, (CatToken.__proto__ || Object.getPrototypeOf(CatToken)).call(this, eth, config));

    _this.tokenContractAddress = config.tokenContractAddress;
    _this.paymentContractAddress = config.paymentContractAddress;

    _this.fetchCatBalance = _this.fetchCatBalance.bind(_this);
    _this.fetchCatAllowance = _this.fetchCatAllowance.bind(_this);
    _this.authorizeCat = _this.authorizeCat.bind(_this);
    _this.authorizeCatTransaction = _this.authorizeCatTransaction.bind(_this);
    return _this;
  }

  /**
   * Fetch the balance of tokens for the given address.
   *
   * @param {String} address
   *
   * @returns {Promise<BN>}
   */


  _createClass(CatToken, [{
    key: 'fetchCatBalance',
    value: function fetchCatBalance(address) {
      return _get(CatToken.prototype.__proto__ || Object.getPrototypeOf(CatToken.prototype), 'fetchBalance', this).call(this, address, this.tokenContractAddress);
    }

    /**
     * Fetch the allowance of tokens the given address has given the CAT payment contract.
     *
     * @param {String} address
     *
     * @returns {Promise<BN>}
     */

  }, {
    key: 'fetchCatAllowance',
    value: function fetchCatAllowance(address) {
      return _get(CatToken.prototype.__proto__ || Object.getPrototypeOf(CatToken.prototype), 'fetchAllowance', this).call(this, address, this.paymentContractAddress, this.tokenContractAddress);
    }

    /**
     * Generate transaction options for authorizing a token allowance,
     * which lets the CAT Payment Contract use the sender's CAT.
     * Pops up a modal to allow the user to choose how much to authorize.
     * This method is deprecated, use authorizeCatTransaction instead.
     *
     * @param {String} senderAddress
     * @param {BN} amount (tokenWei)
     * @param {String} gasPrice (wei)
     * @param {Bool} useInputsModal?
     *
     * @returns {Promise<Object>}
     */

  }, {
    key: 'authorizeCat',
    value: function authorizeCat(senderAddress, amount, gasPrice) {
      var useInputsModal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      console.warn('authorizeCat is deprecated, use authorizeCatTransaction instead');
      return this.authorizeCatTransaction(senderAddress, amount, gasPrice, useInputsModal);
    }

    /**
     * Generate transaction options for authorizing a token allowance,
     * which lets the CAT Payment Contract use the sender's CAT.
     * Pops up a modal to allow the user to choose how much to authorize.
     *
     * @param {String} senderAddress
     * @param {BN} amount (tokenWei)
     * @param {String} gasPrice (wei)
     * @param {Bool} useInputsModal?
     *
     * @returns {Promise<Object>}
     */

  }, {
    key: 'authorizeCatTransaction',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(senderAddress, amount, gasPrice) {
        var useInputsModal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', _get(CatToken.prototype.__proto__ || Object.getPrototypeOf(CatToken.prototype), 'authorizeTransaction', this).call(this, this.paymentContractAddress, amount, senderAddress, this.tokenContractAddress, 'CAT', 18, gasPrice, true, null, useInputsModal));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function authorizeCatTransaction(_x3, _x4, _x5) {
        return _ref.apply(this, arguments);
      }

      return authorizeCatTransaction;
    }()
  }]);

  return CatToken;
}(_DynamicTokenContract3.default);

exports.default = CatToken;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/CatToken.js
// module id = 1279
// module chunks = 0